import { Page } from "../../../components/page-base";
import {
  BottomContainer,
  BtnsContainer,
  Container,
  FormRow,
  RegisterInputContainer,
} from "./styles";
import gpv from "../../../assets/images/logo-georanking.png";
import { InputLogin } from "../components/input";
import { useState } from "react";
import ActionButton from "../components/button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { LoginService } from "../services";
import useUserStore from "../../../store/user";
import { destinoDepoisDoLogin } from "../../../utils/acesso-ao-relatorio";

export const ActiveUserLogin: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useUserStore();

  const handleLogin = async () => {
    if (!email || !password) {
      toast.error("Por favor, preencha todos os campos.");
      return;
    }
    setLoading(true);
    try {
      const response = await LoginService.login(email, password);
      if (response) {
        const t = await LoginService.getCurrentUser(response);

        if (
          t.data?.userType === "ADMIN" ||
          t.data?.userType === "STAFF" ||
          t.data?.userType === "GMAIL_MANAGER" ||
          t.data?.userType === "PORTFOLIO_MANAGER"
        ) {
          setUser({
            name: t.data.name ?? "",
            token: response ?? "",
            userType: t.data.userType,
            businessProfiles: t.data.businessProfiles ?? [],
          });
          navigate(destinoDepoisDoLogin() ?? "/admin");
        } else {
          toast.error("Sem permissão!");
          navigate("/login");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page.Root>
      <Container>
        <FormRow>
          <div className="left-item">
            <img src={gpv} alt="" className="left-image" />
            <span className="left-title">Área do Admin</span>
            <span className="left-subtitle">
              Preencha os dados abaixo para acessar sua conta
            </span>
          </div>
          <div className="right-item">
            <RegisterInputContainer>
              <InputLogin
                placeholder="Email"
                type="text"
                setValue={setEmail}
                value={email}
              />
              <InputLogin
                placeholder="Senha"
                type="password"
                setValue={setPassword}
                value={password}
              />
            </RegisterInputContainer>
            <BtnsContainer>
              <a
                className="link"
                style={{ cursor: "pointer", fontSize: "14px", color: "#1264C7" }}
                onClick={() => navigate("/forgot-password")}
              >
                Esqueceu a senha?
              </a>
              <ActionButton label="Acessar" onClick={handleLogin} />
            </BtnsContainer>
          </div>
        </FormRow>
      </Container>

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
          aria-busy
          aria-live="assertive"
        >
          <Page.Loader />
        </div>
      )}
      <BottomContainer>
        <a
          href="/terms-of-use"
          target="_blank"
          rel="noopener"
          style={{ marginRight: "1vw" }}
        >
          Termos de Uso
        </a>
        <a href="/privacy-policy" target="_blank" rel="noopener">
          Política de Privacidade
        </a>
      </BottomContainer>
    </Page.Root>
  );
};
